module.exports = __webpack_public_path__ + "img/project10_1.5a86ad40.jpg";